import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { DahliaMark } from '@/components/BrandMark';

export default function FounderColourway() {
 const [colourways, setColourways] = useState([]);
 const [chosen, setChosen] = useState('');
 const [saved, setSaved] = useState(false);

 useEffect(() => {
 (async () => {
 const [c, b] = await Promise.all([api.get('/colourways'), api.get('/founders/bundle')]);
 setColourways(c.data.colourways || []);
 setChosen(b.data.selections?.founder_hoodie_color || '');
 })();
 }, []);

 const save = async () => {
 setSaved(false);
 await api.post('/founders/design', { founder_hoodie_color: chosen });
 setSaved(true);
 setTimeout(() => setSaved(false), 2200);
 };

 const chosenObj = colourways.find(c => c.name === chosen);

 return (
 <div className="space-y-6">
 <Panel className="p-8">
 <div className="h-eyebrow">Founder Colourway</div>
 <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Choose your exclusive hoodie colour</div>
 <p className="opacity-80 text-sm mt-2" style={{ color: 'var(--heritage-plum)' }}>Founder colourways are never released to the public. Choose carefully. this becomes your signature.</p>
 </Panel>

 <div className="grid md:grid-cols-[1fr,1.2fr] gap-6">
 <Panel className="p-6">
 <div className="h-eyebrow mb-3">Available colours</div>
 <div className="grid grid-cols-2 gap-3">
 {colourways.map(c => (
 <button key={c.id} onClick={() => setChosen(c.name)}
 className={`p-3 rounded-lg text-left border`}
 style={{ borderColor: chosen === c.name ? 'var(--heritage-plum)' : 'rgba(75,24,56,0.25)', background: chosen === c.name ? '#FBF8F1' : 'transparent' }}
 data-testid={`colourway-${c.name}`}>
 <div className="w-full h-10 rounded-md" style={{ background: c.hex }} />
 <div className="h-serif text-sm mt-2" style={{ color: 'var(--heritage-plum)' }}>{c.name}</div>
 {c.tier_restricted && <div className="h-eyebrow mt-0.5" style={{ color: 'var(--heritage-pinkle)' }}>Founder Exclusive</div>}
 </button>
 ))}
 </div>
 <button className="h-btn mt-6" onClick={save} data-testid="colourway-save">Save colourway</button>
 {saved && <span className="ml-3 h-eyebrow" style={{ color: '#5B6E2C' }}>Saved</span>}
 </Panel>
 <Panel className="p-6 flex flex-col items-center justify-center">
 <div className="h-eyebrow mb-3">Live preview</div>
 <div className="w-full max-w-sm aspect-[3/4] rounded-2xl relative overflow-hidden flex items-center justify-center"
 style={{ background: chosenObj?.hex || '#4B1838', border: '3px solid var(--heritage-plum)' }}>
 <div className="text-center" style={{ color: chosenObj?.hex === '#F6F0E4' ? 'var(--heritage-plum)' : '#fff' }}>
 <div className="opacity-90"><DahliaMark size={64} className="mx-auto" /></div>
 <div className="h-serif text-3xl mt-4 tracking-widest">HERITAGE</div>
 <div className="h-eyebrow mt-1 opacity-80">Founder Hoodie</div>
 </div>
 </div>
 <div className="h-eyebrow mt-4">{chosen || 'Select a colour'}</div>
 </Panel>
 </div>
 </div>
 );
}
